<app-popover #popover [width]="'fit-content'" [class]="'min-w-[12rem] p-2'">
  <ng-template #trigger>
    <app-button variant="outlined" severity="contrast" icon="pi pi-sort-alt" [disabled]="disabled()" />
  </ng-template>

  <ng-template #body>
    <div class="flex flex-col text-sm text-gray-800">
      @for (field of fields(); track field.value) {
      <div class="flex justify-between items-center px-4 py-2 rounded-base cursor-pointer hover:bg-gray-100"
        [ngClass]="{ 'bg-arena-orange-100 text-black': sortField() === field.value }"
        (click)="selectField(field.value)">
        {{ field.label }}
        @if (sortField() === field.value) {
        <app-icon type="pi pi-check" source="primeng" size="xs" variant="primary" />
        }
      </div>
      }
    </div>

    <hr class="my-2" />

    <div class="flex flex-col text-sm text-gray-800">
      <div class="flex justify-between items-center px-4 py-2 rounded-base cursor-pointer hover:bg-gray-100"
        [ngClass]="{ 'bg-arena-orange-100 text-black': sortOrder() === 'asc' }" (click)="selectOrder('asc')">
        {{ 'Ascending' | textCase }}
        <app-icon type="pi pi-arrow-down" source="primeng" size="xs"
          [variant]="sortOrder() === 'asc' ? 'primary' : 'black'" />
      </div>
      <div class="flex justify-between items-center px-4 py-2 rounded-base cursor-pointer hover:bg-gray-100"
        [ngClass]="{ 'bg-arena-orange-100 text-black': sortOrder() === 'desc' }" (click)="selectOrder('desc')">
        {{ 'Descending' | textCase }}
        <app-icon type="pi pi-arrow-up" source="primeng" size="xs"
          [variant]="sortOrder() === 'desc' ? 'primary' : 'black'" />
      </div>
    </div>
  </ng-template>
</app-popover>
